import { AgGridModule } from '@ag-grid-community/angular';
import { Platform } from '@angular/cdk/platform';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { rootRoutes } from '@uigy/app.routing';
import { CoreModule } from '@uigy/core/core.module';
import {
  ClassificationBannerComponent
} from '@uigy/shared/components/classification-banner/classification-banner.component';
import { NagComponent } from '@uigy/shared/components/nag/nag/nag.component';
import { ToasterComponent } from '@uigy/shared/components/toaster/toaster.component';
import { MaterialModule } from '@uigy/shared/material-module/material.module';
import { Services } from '@uigy/shared/services';
import { AppDateAdapter } from '@uigy/shared/services/date-time/DateAdapter';
import { iemInterceptor } from '@uigy/shared/services/iemInterceptor.service';
import { restInterceptor } from '@uigy/shared/services/restInterceptor.service';
import Utils from '@uigy/utils';
import { I18NextModule } from 'angular-i18next';
import { AppComponent } from './core/components/app-component/app.component';

const StoreDevToolOptions = {
  maxAge: 10,
  logOnly: !environment.production
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    CoreModule,
    MaterialModule,
    I18NextModule,
    RouterModule.forRoot(rootRoutes, {}),
    StoreDevtoolsModule.instrument(StoreDevToolOptions),
    AgGridModule,
    ToasterComponent,
    NagComponent,
    ClassificationBannerComponent,
  ],
  providers: [
    Services,
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {disableTooltipInteractivity: true}
    },
    {
      provide: APP_BASE_HREF,
      useFactory: Utils.getBaseLocation
    },
    provideHttpClient(withInterceptors([restInterceptor, iemInterceptor])),
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
      deps: [MAT_DATE_LOCALE, Platform]
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
